import Common from "./common";
import Server from "./server";
import Ajax from "./ajax";
import WxLogin from 'WxLogin';

export default {
    // 在微信开放平台注册开发者账号，并拥有一个已审核通过的"网站应用"，并获得相应的AppID和AppSecret，申请微信登录且通过审核后，可开始接入流程

    // 获取微信登录 code（与 weixin.jsapi 里的 requestCode() 不同，这里使用的是 网站内嵌二维码微信登录JS实现办法）
    // 官方教程：https://developers.weixin.qq.com/doc/oplatform/Website_App/WeChat_Login/Wechat_Login.html
    // 视频教程：https://www.bilibili.com/video/BV1jX4y1Z7ZX/?spm_id_from=333.337.search-card.all.click&vd_source=e40e4759dde9a48aa28169945348e780
    login() {
        const state = Common.generateUuid();
        //const redirectUri = 'http://api.tpqxb.com' + '/weixin/receiveWeChatCodeForLogin_Test';
        const redirectUri = encodeURIComponent(Server.getCloudServiceAddress() + '/weixin/receiveWeChatCodeForLogin');
        return new WxLogin({
            self_redirect: true,
            id: "weixin_login_container",  //页面上必须放一个此id的元素，否则找不到页面中 id="login_container" 的元素会报错。
            appid: "wx908ea4ebb1ad3c05", //来源：微信开放平台 -> 网站应用，选择一个已审核的应用，点详情即可查看到 appid，但是重新审核中的话看不到！
            scope: "snsapi_login",  //网页应用目前仅填写snsapi_login即可
            redirect_uri: redirectUri,  //重定向地址，需要进行UrlEncode。用户允许授权后，将会重定向到redirect_uri的网址上，并且带上code和state参数
            state: state,  //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
            //style: "",  //提供"black"、"white"可选，默认为黑色文字描述。
            //href: "",   //自定义样式链接
            onReady: function (isReady) {
                //显示二维码后就会触发此方法
                console.log(isReady);
            }
        });
    }
}